import React from 'react'
import { Alert, Button, Group, List, Stack, Text } from '@mantine/core'

import {
  CA_INSTRUCTIONS_URL,
  CA_NOTICE_CHECKLIST_URL,
  WA_INSTRUCTIONS_URL,
} from '@/components/Event/CrForm/stateRecordScripts'
import { Event } from '@/types'

const CR_EVENTS_URL =
  'https://dbf-digital-reporters.helpscoutdocs.com/article/382-court-reporter-events'

const ArticleButton: React.FC<{ href: string; children: React.ReactNode }> = ({
  href,
  children,
}) => (
  <Button
    component="a"
    href={href}
    target="_blank"
    rel="noreferrer"
    variant="light"
    size="xs"
    compact
  >
    {children}
  </Button>
)

export const PreparationInfoAlert: React.FC<{
  event: Event
  title?: string
}> = ({ event, title }) => {
  const state = event.case.state

  return (
    <Alert title={title}>
      <Text size="sm" fw={600} mb="xs">
        Help articles:
      </Text>
      <Stack>
        <Group spacing="sm">
          <ArticleButton href={CR_EVENTS_URL}>
            Court Reporter Events Instructions
          </ArticleButton>
          {state === 'CA' && (
            <>
              <ArticleButton href={CA_INSTRUCTIONS_URL}>
                California Instructions
              </ArticleButton>
              <ArticleButton href={CA_NOTICE_CHECKLIST_URL}>
                California Notice Checklist
              </ArticleButton>
            </>
          )}
          {state === 'WA' && (
            <ArticleButton href={WA_INSTRUCTIONS_URL}>
              Washington Instructions
            </ArticleButton>
          )}
        </Group>

        <Text size="sm">
          If the Court Reporter or a listed Videographer is not present
          immediately after joining, please inform our support team.
        </Text>

        <div>
          <Text size="sm" fw={600}>
            Preparation steps:
          </Text>
          <List type="ordered" withPadding style={{ listStyle: 'ordered' }}>
            <List.Item>
              Rename yourself in Zoom to "Filevine - Session Assistant" (unless
              state-specific instructions say otherwise).
            </List.Item>
            <List.Item>Create at least two breakout rooms.</List.Item>
            <List.Item>
              Open live transcript to test working playback.
            </List.Item>
            <List.Item>Open notice to review the details.</List.Item>
          </List>
        </div>
      </Stack>
    </Alert>
  )
}
